var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEngineReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    fill: "#E8EDF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4720_38487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9716 16.2808C35.7953 16.1012 35.5542 16 35.3026 16H29.5938V20.375H39.9905L35.9716 16.2808Z",
    fill: "url(#paint0_linear_4720_38487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7194 16H23.6634C23.4136 16 23.1741 16.0997 22.9981 16.277L18.9297 20.375H27.7194V16Z",
    fill: "url(#paint1_linear_4720_38487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4795 29.9058C26.4795 28.0246 24.9491 26.4941 23.0679 26.4941C21.1867 26.4941 19.6562 28.0246 19.6562 29.9058C19.6562 31.787 21.1867 33.3175 23.0679 33.3175C24.9491 33.3175 26.4795 31.787 26.4795 29.9058ZM22.1304 29.9058C22.1304 29.3888 22.5509 28.9683 23.0679 28.9683C23.5848 28.9683 24.0054 29.3888 24.0054 29.9058C24.0054 30.4227 23.5848 30.8433 23.0679 30.8433C22.5509 30.8433 22.1304 30.4227 22.1304 29.9058Z",
    fill: "url(#paint2_linear_4720_38487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9373 22.25H18.8127C17.2617 22.25 16 23.5107 16 25.0603V27.2522C16 28.4383 16.7396 29.4544 17.7819 29.8662C17.8033 26.9693 20.1657 24.6189 23.0675 24.6189C25.9826 24.6189 28.3541 26.9905 28.3541 29.9056C28.3541 29.9582 28.3517 30.0103 28.3501 30.0625H35.1598C35.1583 30.0103 35.1558 29.9582 35.1558 29.9056C35.1558 26.9905 37.5274 24.6189 40.4424 24.6189C43.3575 24.6189 45.7291 26.9905 45.7291 29.9056C45.7291 29.9582 45.7266 30.0103 45.7251 30.0625H47.0625C47.5802 30.0625 48 29.6427 48 29.125V27.3127C48 24.5211 45.7289 22.25 42.9373 22.25Z",
    fill: "url(#paint3_linear_4720_38487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8545 29.9058C43.8545 28.0246 42.3241 26.4941 40.4429 26.4941C38.5617 26.4941 37.0312 28.0246 37.0312 29.9058C37.0312 31.787 38.5617 33.3175 40.4429 33.3175C42.3241 33.3175 43.8545 31.787 43.8545 29.9058ZM39.5054 29.9058C39.5054 29.3888 39.9259 28.9683 40.4429 28.9683C40.9598 28.9683 41.3804 29.3888 41.3804 29.9058C41.3804 30.4227 40.9598 30.8433 40.4429 30.8433C39.9259 30.8433 39.5054 30.4227 39.5054 29.9058Z",
    fill: "url(#paint4_linear_4720_38487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8724 44.2507H40.5946L34.0381 40.8652L41.3612 37.084H45.8698C46.3876 37.084 46.8073 36.6642 46.8073 36.1465C46.8073 35.6287 46.3876 35.209 45.8698 35.209H18.1198C17.6021 35.209 17.1823 35.6287 17.1823 36.1465C17.1823 36.6642 17.6021 37.084 18.1198 37.084H22.6284L29.9515 40.8652L23.395 44.2507H18.1172C17.5994 44.2507 17.1797 44.6704 17.1797 45.1882V47.0632C17.1797 47.5809 17.5994 48.0007 18.1172 48.0007H45.8724C46.3901 48.0007 46.8099 47.5809 46.8099 47.0632V45.1882C46.8099 44.6704 46.3901 44.2507 45.8724 44.2507ZM26.7151 37.084H37.2744L31.9947 39.8102L26.7151 37.084ZM27.4818 44.2507L31.9947 41.9204L36.5078 44.2507H27.4818Z",
    fill: "url(#paint5_linear_4720_38487)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4720_38487",
    x1: 29.5937,
    y1: 16,
    x2: 38.4768,
    y2: 22.4573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2836D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E93D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4720_38487",
    x1: 18.9297,
    y1: 16,
    x2: 27.2613,
    y2: 21.1203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2836D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E93D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4720_38487",
    x1: 19.6562,
    y1: 26.4941,
    x2: 27.8043,
    y2: 28.9866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2836D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E93D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4720_38487",
    x1: 16,
    y1: 22.25,
    x2: 32.261,
    y2: 42.6241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2836D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E93D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4720_38487",
    x1: 37.0312,
    y1: 26.4941,
    x2: 45.1793,
    y2: 28.9866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2836D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E93D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4720_38487",
    x1: 17.1797,
    y1: 35.209,
    x2: 42.9402,
    y2: 53.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2836D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E93D7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4720_38487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineReport);
export default __webpack_public_path__ + "static/media/engineReport.ec621b67c8ba640b04168323fdddad3f.svg";
export { ForwardRef as ReactComponent };